import { useIcon } from '../context/Icons';
import { CloseIcon } from '../icons/CloseIcon';
import { Sidebar } from './stage-sidebar/Sidebar';
import { Preview } from './Preview';

export const Stage = () => {
  const { stageIcon, closeIcon } = useIcon();
  const showStage = !!stageIcon;

  if (showStage) {
    return (
      <div className="icon-library--stage-wrapper box-border h-full overflow-hidden absolute inset-0 w-full z-10 bg-gray p-4">
        <div className="icon-library--stage flex h-full relative">
          <Preview />
          <div className="pr-4" />
          <Sidebar />
        </div>
        <div
          className="icon-library--stage-close bg-white cursor-pointer h-10 absolute top-0 left-0 w-10 border-gray border-solid border m-2 shadow-sm transition"
          onClick={closeIcon}
        >
          <CloseIcon />
        </div>
      </div>
    );
  }
  return null;
};
